// removed by extract-text-webpack-plugin
module.exports = {"Input":"-name__-loca-__s67N0","Label":"-name__-loca-___n-1m","InputElement":"-name__-loca-__2-aFx","Invalid":"-name__-loca-__1sl1p"};


//////////////////
// WEBPACK FOOTER
// ./src/components/UI/Input/Input.css
// module id = 190
// module chunks = 0